module.exports = __webpack_public_path__ + "img/motoboy-03.dca06943.svg";